import { Component, Host, h, Element } from '@stencil/core';

export interface AhaFolderThumbnail extends HTMLAhaFolderThumbnailElement {}

/**
 * aha-folder-thumbnail component, used to display folders and parent notes.
 * @slot title - Contents of the title slot.
 * @slot description-body - Contents of the description-body slot.
 * @slot default - Contents of the default slot.
 */
@Component({
  tag: 'aha-folder-thumbnail',
  styleUrl: 'aha-folder-thumbnail.css',
  shadow: true,
})
export class AhaFolderThumbnail {
  @Element() host!: HTMLAhaFolderThumbnailElement;
  render() {
    return (
      <Host>
        <div id="aha-folder-thumbnail--title">
          <slot name="title"></slot>
        </div>
        <div id="aha-folder-thumbnail--description-body">
          <slot name="description-body"></slot>
        </div>
        <slot></slot>
      </Host>
    );
  }
}
